import React, { FC, useCallback, useEffect, useState } from 'react'
import { Button } from '@wmgtech/legato'

import { cn } from 'shared/utils'
import { QuillForm } from 'modulesCommon/Forms/components'

import { formatProjectInfo } from 'shared/utils/quillForm'

import { IEditorTextBlock } from './EditorTextBlock.props'

import 'react-quill/dist/quill.snow.css'
import './EditorTextBlock.scss'

const EditorTextBlock: FC<IEditorTextBlock> = ({
  info,
  isActive,
  onUpdateInfo,
  title,
  isProject = false,
  isLocalized,
  field,
  dataTest
}) => {
  const [edit, setEdit] = useState(false)
  const [data, setData] = useState('')

  useEffect(() => {
    if (info) setData(info)
  }, [info])

  const toggleEdit = useCallback(() => setEdit(!edit), [edit])

  const onChangeInfo = useCallback((newData: string) => setData(newData), [])

  const onSaveInfo = useCallback(
    () => data && onUpdateInfo && onUpdateInfo({ [field]: data }).then(() => toggleEdit()),
    [data, field, onUpdateInfo, toggleEdit]
  )

  const onCancel = useCallback(() => {
    setData(info)
    toggleEdit()
  }, [info, toggleEdit])

  return (
    <div className={cn('editor', { 'editor-local': isLocalized})}>
      <div className="editor-header">
        <h2>{title}</h2>
        {
          isActive ? (
            edit ? (
              <div>
                <Button
                  className="editor-header__btn"
                  colorType="secondary-black"
                  containerStyle="outline"
                  label="Cancel"
                  onClick={onCancel}
                  size="sm"
                />
                <Button
                  className="editor-header__save-btn"
                  colorType="secondary-black"
                  containerStyle="solid"
                  label="Save"
                  size="sm"
                  onClick={onSaveInfo}
                />
              </div>
            ) : (
              <Button
                data-edit-mode
                className="editor-header__btn"
                containerStyle="outline"
                colorType="secondary-black"
                onClick={toggleEdit}
                label="Edit"
                secondaryIcon="pencil"
                size="sm"
              />
            )
          ) : null
        }
      </div>
      {
        edit ? (
          <QuillForm
            isDisabled={false}
            onChange={onChangeInfo}
            initialData={data}
            hideLabel
            label={title}
            field={field}
            isProject={isProject}
          />
        ) : (
          <div className="quill-form__block">
            <div className="editor__details">
              {info ? (
                <div
                  data-test={dataTest}
                  className="ql-editor ql-render"
                  dangerouslySetInnerHTML={{
                    __html: isProject ? formatProjectInfo(data || info) : data || info
                  }}
                />
              ) : (
                <div data-test={dataTest} className="editor__details-empty">No {title} provided</div>
              )}
            </div>
          </div>
        )
      }
    </div>
  )
}

export default EditorTextBlock
